import React from "react";
import { connect } from "react-redux";
import { getActiveImagesByMovementId } from "core/store/selectors/OrdersSelectors";
import { IndicatorActionButton } from "common";
import { CropOriginal } from "@material-ui/icons";

function ImagesIndicatorActionPresentation({ movementId, images = [], index = 0 }) {
  return (
    <IndicatorActionButton
      color="primary"
      index={index}
      movementId={movementId}
      disabled={!images.length}
      icon={CropOriginal}
    />
  );
}

const mapStateToProps = (state, { movementId }) => ({
  images: getActiveImagesByMovementId(state, movementId)
});

export const ImagesIndicatorAction = connect(mapStateToProps)(ImagesIndicatorActionPresentation);
